<template>
  <div>
    <div class="list-filters mb-1">
      <div class="d-flex justify-content-between">
        <h4>Filtros</h4>
        <div v-if="requests.length">
          <b>Total de Registros: </b> <b-badge variant="success" >  {{requests.length}} </b-badge>
          <b-button
            type="button"
            size="sm"
            class="btn fives-club-excel-btn ml-1"
            :disabled="isLoadingData || requests.length < 1"
            @click="getExcel"
            v-if="requests.length && !isDowloadingExcel"> <feather-icon icon="FileTextIcon" /> Excel <b-spinner small label="Loading..." v-if="isDowloadingExcel"/>
          </b-button>
        </div>
      </div>
      <validation-observer tag="form" ref="filterTransactionsAceptance">
        <b-form @submit.prevent="searchByFilter">
          <b-row>
            <b-col class="label-text" md="">
              <validation-provider name="Nombre o apellido" rules="">
                <b-form-group slot-scope="{ valid, errors }">
                  <label>Nombre o apellido</label>
                  <b-form-input
                    @keypress="onlyNumbersLetters"
                    v-model="searchFilter.nameOwner"
                    :state="errors[0] || !valid ? false : null"
                    placeholder="Nombre o apellido"
                  />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="">
              <validation-provider name="resort" rules="">
                <b-form-group slot-scope="{ valid, errors }">
                  <label>Resort</label>
                  <b-form-select
                    :state="errors[0] || !valid ? false : null"
                    v-model="searchFilter.resort"
                    :clearable="false"
                  >
                    <option :value="null">Seleccione una opción</option>
                    <option v-for="h in hotels" :key="h.id" :value="h.id"> {{ h.name }}</option>
                  </b-form-select>
                  <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col class="label-text" md="">
              <validation-provider name="número vivienda" rules="">
                <b-form-group slot-scope="{ valid, errors }">
                  <label>Vivienda</label>
                  <b-form-input
                    @keypress="onlyNumber"
                    v-model="searchFilter.numberHousing"
                    :state="errors[0] || !valid ? false : null"
                    placeholder="Número de vivienda"
                  />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="">
              <validation-provider name="Fechas de transacción" rules="">
                <b-form-group slot-scope="{ errors }">
                  <label>Fechas de transacción</label>
                  <flat-pickr
                    :class="`form-control flatpickr-color ${errors.length > 0 ? 'is-invalid' : ''}`"
                    :config="dateConfig"
                    v-model="searchFilter.signDate"
                    placeholder="Seleccione una fecha"
                  />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="">
              <validation-provider name="membresía">
                <b-form-group slot-scope="{ valid, errors }">
                  <label>Membresía</label>
                  <b-form-select
                    :state="errors[0] || !valid ? false : null"
                    v-model="searchFilter.membership"
                    :clearable="false"
                  >
                    <option :value="null">Seleccione un opción</option>
                    <option
                      v-for="mmbr in membershipsOptions"
                      :key="mmbr.id"
                      :value="mmbr.id"
                    >
                      {{ mmbr.code }}
                    </option>
                  </b-form-select>
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col class="label-text" md="">
              <validation-provider name="contrato" rules="">
                <b-form-group slot-scope="{ valid, errors }">
                  <label>Contrato</label>
                  <b-form-input
                    @keypress="onlyNumbersLetters"
                    v-model="searchFilter.contract"
                    :state="errors[0] || !valid ? false : null"
                    placeholder="Contrato"
                  />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="">
              <validation-provider name="Estado">
                <b-form-group slot-scope="{ valid, errors }">
                  <label>Estado</label>
                  <b-form-select
                    :state="errors[0] || !valid ? false : null"
                    v-model="searchFilter.status"
                    :clearable="false"
                  >
                    <option :value="null">Seleccione un opción</option>
                    <option
                      v-for="status in statusFilter"
                      :key="status.id"
                      :value="status.id"
                    >
                      {{ status.name }}
                    </option>
                  </b-form-select>
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="">
              <validation-provider name="Resolución">
                <b-form-group slot-scope="{ valid, errors }">
                  <label>Resolución</label>
                  <b-form-select
                    :state="errors[0] || !valid ? false : null"
                    v-model="searchFilter.reviewStatus"
                    :clearable="false"
                  >
                    <option :value="null">Seleccione un opción</option>
                    <option
                      v-for="status in statusReviewFilter"
                      :key="status.id"
                      :value="status.id"
                    >
                      {{ status.name }}
                    </option>
                  </b-form-select>
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

          </b-row>

          <b-row>
            <b-col cols="">
              <div class="float-right">
                <b-button
                  variant="warning"
                  :disabled="isLoadingData"
                  @click="resetTable"
                > Reset
                </b-button>
                <!-- <b-button
                  type="button"
                  v-if="requests.length"
                  variant="success"
                  class="ml-1"
                  :disabled="isLoadingData "
                  @click="getExcel"
                > Excel
                </b-button> -->
                <b-button
                  type="submit"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="ml-1"
                  :disabled="isLoadingData"
                > Buscar
                </b-button>
              </div>
            </b-col>

          </b-row>
        </b-form>
      </validation-observer>
    </div>

    <b-row v-if="requests.length" class="mb-1">
      <b-col md="2">
        <label>Numero de registros</label>
        <v-select
          v-model="porPagina"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="perPageOptions"
          :clearable="false"
          class="per-page-selector"
          @input="changePerPage"
        />
      </b-col>
      <b-col md="4">
        <label>Buscar en tabla</label>
        <div class="d-flex">
          <b-form-input
            v-model="search"
            class="mr-1"
            placeholder="Buscar..."
            type="search"
            @input="searchInRecords"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { utils } from '@/modules/fivesClub/mixins/utils'
import flatPickr from "vue-flatpickr-component";

export default {
	mixins: [utils],
  directives: {
    Ripple,
  },
  props: {
    requests: {
      type: Array,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    perPageOptions: {
      type: Array,
      required: true,
    },
    searchQuery: {
      type: String,
      required: true,
    },
    isLoadingData: {
      type: Boolean,
      required: true,
    }
  },
  components: {
    vSelect,
    flatPickr
  },
  data() {
    return {
      subcondosfiltered: null,

      porPagina: this.perPage,
      statusFilter: [
        {id: '1', name: 'Aceptada'},
        {id: '2', name: 'Rechazada'},
      ],
      statusReviewFilter: [
        {id: '1', name: 'Pendiente'},
        {id: '2', name: 'Resuelto'},
        {id: '3', name: 'Cerrado'},
      ],
      search: this.searchQuery,

      filtro: [
        {value: 'startDate', text: 'Fecha de Inicio'},
        {value: 'endDate', text: 'Fecha Fin'},
        {value: 'rangeDate', text: 'Fechas Inicio - Fin'},
      ],

      dateConfig: {
        mode: 'range'
      },

      searchFilter: {
        nameOwner: null,
        resort: null,
        numberHousing: null,
        membership: null,
        contract: null,
        signDate: null,
        status: null,
        reviewStatus: null,
        excel: null
      },

      isDowloadingExcel: false
    };
  },
  computed: {
    ...mapState('fivesClubCatalogs',['hotels']),
    ...mapState('fivesClubCatalogs', ['membershipsOptions']),

  },
  methods: {
    changePerPage(perPage) {
      this.$emit('change-per-page', perPage);
      this.porPagina = perPage;
    },
    searchInRecords( query ){
      this.$emit('search-in-table-records', query)
      this.search = query
    },
    resetFilterOwners(){
      this.searchFilter = {
        nameOwner: null,
        resort: null,
        numberHousing: null,
        membership: null,
        contract: null,
        signDate: null,
        startDate: null,
        endDate: null,
        status: null,
        reviewStatus: null,
        excel: null
      }
    },
    async resetTable(){
      this.resetFilterOwners()
      this.$refs.filterTransactionsAceptance.reset()
      this.porPagina = 10
      this.$emit("reset-filter")
    },
    async getExcel(){
      this.isDowloadingExcel = true
      this.searchFilter.excel = true
      await this.searchByFilter()
      this.searchFilter.excel = null
      this.isDowloadingExcel = false
    },
    async searchByFilter() {
      const valid = await this.$refs.filterTransactionsAceptance.validate()
      if (valid) {
        if (this.searchFilter?.signDate?.includes("to")) {
          const rangeDate = this.searchFilter.signDate.split(" to ")
          this.searchFilter.startDate = rangeDate[0]
          this.searchFilter.endDate = rangeDate[1]
        }
        this.$emit("look-per-filter", this.searchFilter);
      }
    },
  },
}
</script>


<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
.flatpickr-color{
  background-color: white !important;
}
.flatpickr-color:disabled{
  background-color: #efefef !important;
}
.isCentered {
  align-content: center;
  align-items: center;
}
.isSpinner {
  padding: 2rem;
}

.paddler {
  padding-left: 1rem;
}

.custom-margin-buttons{
  margin-top: 1.7rem;
}
</style>
